export default function PrivacyPage() {
  return (
    <section className="legal">
      <h1>Privacy Policy</h1>
      <p className="muted">Last updated: 2026. Please review this policy with your own counsel before relying on it.</p>

      <h2>1. Information we collect</h2>
      <p>
        Account identity and email (via Clerk); for sellers, legal name, phone, mailing address,
        Giants Account Manager ID, and seat-verification photos; transaction details and payout
        information (via Stripe). We do not store full card numbers — payments are handled by Stripe.
      </p>

      <h2>2. How we use it</h2>
      <p>
        To operate the marketplace: verify sellers and seats, process payments and payouts, deliver
        notifications, resolve disputes, prevent fraud, and meet legal obligations.
      </p>

      <h2>3. Sharing</h2>
      <p>
        We share data with service providers that make NYGTIX work — Clerk (authentication), Stripe
        (payments/payouts), and our email provider. After a purchase, a buyer and seller see the
        limited contact details needed to complete the ticket transfer. We do not sell your personal
        information.
      </p>

      <h2>4. Retention and security</h2>
      <p>
        We keep verification photos and transaction records as long as needed to operate the service
        and meet legal/accounting requirements, then delete or anonymize them. Verification photos
        are stored privately and are accessible only to you and NYGTIX administrators.
      </p>

      <h2>5. Your choices</h2>
      <p>
        You may request access to or deletion of your personal information, subject to records we
        must retain. Contact us to exercise these rights.
      </p>

      <h2>6. Changes</h2>
      <p>We may update this policy; we will post the current version here.</p>
    </section>
  );
}
